/**
 * Return a config value from the global object
 * Parse boolean values because all config values are set as string during the CI
 * @param {String} key Config key
 * @return {String|Boolean} config value
 */
export function getConfig(key) {
    if (key in MA.Config) {
        const value = MA.Config[key];
        if (value === 'true') {
            return true;
        } else if (value === 'false') {
            return false;
        } else {
            return value;
        }
    }
    return null;
}
